(function(angular) {

  var Error = function() {
    return {
      templateUrl: 'errors.html',
      restrict: 'AEC',
      transclude: true,
      scope: {
        $field: '=field',
        $custom: '=custom',
        $customMessage: '=customMessage'
      }
    }
  };

  angular.module('ins.models').directive('error', Error);

})(window.angular);